/** WebSocket STOMP brokerURL */
export function getWsBrokerURL(token: string): string {
  const isHttpProxy = import.meta.env.DEV && import.meta.env.VITE_HTTP_PROXY === 'Y';

  let wsOrigin: string;

  if (isHttpProxy) {
    // 开发代理：Vite /ws → 后端
    const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    wsOrigin = `${wsProtocol}://${window.location.host}`;
  } else {
    // 开发直连后端（VITE_HTTP_PROXY=N）
    const httpUrl = new URL(import.meta.env.VITE_SERVICE_BASE_URL);
    const wsProtocol = httpUrl.protocol === 'https:' ? 'wss' : 'ws';
    wsOrigin = `${wsProtocol}://${httpUrl.host}`;
  }

  return `${wsOrigin}/ws?token=${encodeURIComponent(token)}`;
}

/** @deprecated 使用 getWsBrokerURL */
export const getScriptWsBrokerURL = getWsBrokerURL;
